<template>

	<dialog-slot
			title="Create payment"
			@updateClose="onClose"
			@updateSave="onSave"
			apply-text="Create payment"
			width="650px"
	>

		<row>
			<field
					:class-error="getError('customer_id')"
					margin="0 10px 0 0"
					width="300px"
					label="Customer"
					placeholder="Select customer"
					@updateAutocomplete="onAutocomplete($event, 'customer_id')"
					:autocompleteValue="customer_id"
					:items="customers"
					:isClearable="false"
					is-autocomplete
					is-required
			></field>
			<field
					:class-error="getError('driver_id')"
					margin="0"
					width="300px"
					label="Driver"
					placeholder="Select driver"
					@updateAutocomplete="onAutocomplete($event, 'driver_id')"
					:autocompleteValue="driver_id"
					:items="drivers"
					:isClearable="false"
					item-text="name"
					item-value="driver_id"
					is-autocomplete
					:is-disabled="!customer_id"
					is-required
			></field>
		</row>
		<row>
			<field
					:class-error="getError('truck_id')"
					margin="0 10px 0 0"
					width="300px"
					label="Truck #"
					placeholder="Select truck"
					@updateAutocomplete="onAutocomplete($event, 'truck_id')"
					:autocompleteValue="truck_id"
					:items="trucks"
					:isClearable="false"
					:is-disabled="!customer_id"
					is-autocomplete
					is-required
			></field>
			<field
					:class-error="getError('category_id')"
					margin="0"
					width="300px"
					label="Category"
					placeholder="Select category"
					@updateSelect="onAutocomplete($event, 'category_id')"
					:autocompleteValue="category_id"
					:items="category"
					item-text="name"
					:isClearable="false"
					is-select
					is-required
			></field>
		</row>
		<row>
			<field
					:class-error="getError('payment_type_id')"
					margin="0 10px 0 0"
					width="300px"
					label="Payment type"
					placeholder="Select payment"
					@updateSelect="onAutocomplete($event, 'payment_type_id')"
					:autocompleteValue="payment_type_id"
					:items="paymentsList"
					item-text="name"
					:isClearable="false"
					is-select
			></field>
			<field
					:class-error="getError('amount')"
					margin="0"
					width="300px"
					label="Amount"
					placeholder="Select amount"
					type="number"
					:setInputValue="amount"
					@updateInput="onInput($event, 'amount')"
					is-required
			></field>
		</row>
		<row>
			<field
					:class-error="getError('charge_from')"
					margin="0 10px 0 0"
					width="300px"
					type="text"
					label="Charge from"
					placeholder="Enter charge from"
					:dateValue="charge_from"
					@updateDate="onDate"
					is-no-title
					is-date
					is-required
			></field>
			<field
					:class-error="getError('charge_every_id')"
					margin="0"
					width="300px"
					label="Сharge every"
					placeholder="Select charge"
					@updateSelect="onAutocomplete($event, 'charge_every_id')"
					:autocompleteValue="charge_every_id"
					:items="charge_every"
					item-text="name"
					:isClearable="false"
					is-select
			></field>
		</row>
		<row>
			<field
					:class-error="getError('charge_amount')"
					v-if="payment_type_id === 2"
					margin="0 10px 0 0"
					width="300px"
					label="Charge amount"
					placeholder="Select charge amount"
					type="number"
					:setInputValue="charge_amount"
					@updateInput="onInput($event, 'charge_amount')"
					is-required
			></field>
			<field
					:class-error="getError('number_payments')"
					margin="0"
					width="300px"
					type="number"
					label="Number of payments"
					placeholder="Enter value"
					:setInputValue="number_payments"
					tooltip="0 - unlimited payments"
					@updateInput="onInput($event, 'number_payments')"
					is-required
			></field>
		</row>
		<field
				margin="0 0 10px"
				padding="10px 10px 0 10px"
				width="100%"
				min-height="64px"
				label="Description"
				placeholder="Enter you comments"
				:setInputValue="description"
				@updateInput="onInput($event, 'description')"
				is-textarea
		></field>

	</dialog-slot>
</template>

<script>
import { mapActions } from "vuex";
// components
// validations
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "CreatePayment",
	mixins: [ validationMixin ],
	components: {
		DialogSlot,

	},
	props: {
		equipments: Array,
		editItem: Object
	},
	data: () => ({
		customer_id: null,
		driver_id: null,
		truck_id: null,
		category_id: null,
		payment_type_id: 1,
		charge_every_id: 1,
		amount: '',
		charge_from: '',
		charge_amount: '',
		number_payments: 1,
		description: '',
		category: [],
		charge_every: [],
		customers: [],
		drivers: [],
		paymentsList: [],
		trucks: []
	}),
	validations() {
		const isChargeAmount = this['payment_type_id'] === 1 ? {} : { required };
		return {
			customer_id: { required },
			driver_id: { required },
			truck_id: { required },
			payment_type_id: { required },
			charge_every_id: { required },
			amount: { required },
			charge_from: { required },
			charge_amount: isChargeAmount,
			number_payments: { required },
			category_id: { required }
		};
	},
	methods: {
		...mapActions([ 'onCalendar', 'onCalendarCreate', 'setAlert' ]),
		getError(key) {
			return this.$v[key] && this.$v[key].$error;
		},
		onReturnedDateRequired() {
			return this.returned;
		},
		onClose() {
			this.$emit('updateClose');
		},
		async onAutocomplete({ value }, key) {
			this[key] = (value?.driver_id || value?.id) ?? value;

			if (key === 'customer_id') {
				this.driver_id = null;
				this.truck_id = null;

				const { drivers, trucks } = await this.onCalendar(this[key]);

				this.drivers = drivers;
				this.trucks = trucks;
			}

			if (key === 'payment_type_id') {
				this.$nextTick(() => this.countAmount(key, this['amount'], this['charge_amount'], this['number_payments']));
			}
		},
		onSearchText(name) {
			this.$emit('updateSearchText', name);
		},
		countAmount(key, amount = 0, changeAmount = 0, numberPayments = 1) {
			if (this.payment_type_id === 2) {
				if (key === 'amount' || key === 'number_payments' || key === 'payment_type_id') {
					const sum = (amount / numberPayments);
					const isDouble = sum.toString().includes('.');
					this['charge_amount'] = isDouble ? sum.toFixed(2) : sum;
				}

				if (key === 'charge_amount') {
					if (!this['charge_amount']) {
						this['number_payments'] = 1;
						this['charge_amount'] = amount;
						return false;
					}

					if (+this['amount'] >= +this['charge_amount']) {
						const sum = (amount / changeAmount).toString();
						const round = parseInt(sum);
						this['number_payments'] = sum.includes('.') ? round + 1 : round;
					} else {
						this['charge_amount'] = amount;
						this.setAlert({ type: "error", message: "Change amount should be less then amount" });
					}
				}
			}
		},
		onInput({ value }, key) {
			this[key] = value;
			this.$nextTick(() => {
				this.countAmount(key, this['amount'], this['charge_amount'], this['number_payments']);
			});
		},
		onDate(value) {
			this.charge_from = value;
		},
		onCheckbox(value, key) {
			this[key] = value;
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					customer_id,
					driver_id,
					truck_id,
					category_id,
					payment_type_id,
					amount,
					charge_from,
					charge_every_id,
					number_payments,
					charge_amount,
					description
				} = this.$data;

				const values = {
					customer_id,
					driver_id,
					truck_id,
					category_id,
					payment_type_id,
					amount,
					charge_from,
					charge_every_id,
					number_payments,
					charge_amount,
					description
				};

				const { status } = await this.onCalendarCreate(values);
				if (status) {
					this.onClose();
				} else {
					this.setAlert({ type: "error", message: "Saving error" });
				}
			}
		}
	},
	async mounted() {
		const {
			category,
			charge_every,
			customers,
			drivers,
			payment_type,
			trucks
		} = await this.onCalendar();

		this.category = category;
		this.charge_every = charge_every;
		this.customers = customers;
		this.drivers = drivers;
		this.paymentsList = payment_type;
		this.trucks = trucks;
	}
};
</script>

<style scoped lang="scss">
@import "CreatePayment";
</style>
<style lang="scss">
.equipmentCheckbox .v-label{
	font-size: 14px;
	line-height: 20px;
}
</style>

